import type { ApiClient } from '../client';

// Restore a «Entrega» to its collectable state (Stored/Expired, computed server-side). The id
// rides the path (url-encoded); the client attaches the Firebase token via the Authorization
// header. Empty 200 — nothing to parse; the caller refetches the detail to surface the new state.
export async function enableDelivery(client: ApiClient, id: string): Promise<void> {
  await client.post(`/app_service/panel/v1/deliveries/${encodeURIComponent(id)}/enable`);
}
